import React from 'react'
import { makeStyles } from "@material-ui/core/styles";
import BaseLayout from '../BaseLayout/index'
import Grid from "@material-ui/core/Grid";
import MyCard from './MyCard'

const useStyles = makeStyles(({ breakpoints, spacing }, theme) => ({
  root: {
    flexGrow: 1,
    //background: "#000714",
  },
}));

function MyNFT() {
  const features = [{
    index:"1",
    header:"Hashmasks",
    imageUrl:'https://via.placeholder.com/180',
    message:"Lizards are a widespread group of squamate reptiles",
    buttonMessage:"BUY OUT"
  },
  {
    index:"2",
    header:"Hashmasks",
    imageUrl:'https://via.placeholder.com/180',
    message:"Lizards are a widespread group of squamate reptiles",
    buttonMessage:"BUY OUT"
  },
  {
    index:"3",
    header:"Hashmasks",
    imageUrl:'https://via.placeholder.com/180',
    message:"Lizards are a widespread group of squamate reptiles",
    buttonMessage:"BUY OUT"
  },
  {
    index:"4",
    header:"Hashmasks",
    imageUrl:'https://via.placeholder.com/180',
    message:"Lizards are a widespread group of squamate reptiles",
    buttonMessage:"BUY OUT"
  },
  {
    index:"4",
    header:"Hashmasks",
    imageUrl:'https://via.placeholder.com/180',
    message:"Lizards are a widespread group of squamate reptiles",
    buttonMessage:"BUY OUT"
  },
  {
    index:"4",
    header:"Hashmasks",
    imageUrl:'https://via.placeholder.com/180',
    message:"Lizards are a widespread group of squamate reptiles",
    buttonMessage:"BUY OUT"
  },

];

  const classes = useStyles();
  return (
    <BaseLayout className={classes.root}>
      <div className="mynft-container">
        <Grid container style={{height:'100vh',width:'80%',paddingLeft:'20%'}}>   
            {features.map(feature=>{
                return (
                  <Grid item xs={12} sm={4}>
                  <MyCard header={feature.header} imageUrl={feature.imageUrl} message={feature.message} buttonMessage={feature.buttonMessage}/>
                  </Grid>
              )
          })}
          </Grid>
        
      </div>
    </BaseLayout>
  )
}

export default MyNFT
